// 职责：负责管理当前系统中的所有公共的配置
export default{
    apiurl:'http://api.fang99.cc',  // 所有数据api的域名地址
    imgurl:'http://img.fang99.cc/'  // 所有图片的域名地址
}


// WEBPACK FOOTER //
// ./src/config/common.js